import { FC, useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";

import { 
  selectAuthCompetitorsRegister, 
  selectAuthLoadingCompetitors, 
  selectAuthStepRegister 
} from "../../store/selectors/auth";
import {
  setStepRegister,
  setSelectedCompetitorsRegister,
  setBrand,
  fetchBrandRegister,
  fetchCompetitorsRegister,
  setCompetitorsRegister,
  setPlan
} from "../../store/auth/slice";
import AddBrand from "../AddBrand/AddBrand";
import SelectionCompetitors from "../SelectionCompetitors/SelectionCompetitors";
import Step3 from "./Components/Step3/Step3";
import { Company, RegisterOAuth } from "../../store/auth/types";
import { CompetitorWithLogo } from "../../types/competitor";
import { parseRegisterOAuthQuery } from "../../store/auth/utils/registerOAuthQuery";

const Register: FC = () => {
  const dispatch = useDispatch();
  const { search } = useLocation();
  const step = useSelector(selectAuthStepRegister);
  const competitorsState = useSelector(selectAuthCompetitorsRegister);
  const loading = useSelector(selectAuthLoadingCompetitors);

  useLayoutEffect(() => {
    const params = new URLSearchParams(search);
    const { company, competitors, selectedCompetitors, plan } = parseRegisterOAuthQuery(
      params.toString()
    ) as RegisterOAuth;

    let currentStep = 1;

    if (plan) {
      dispatch(setPlan(plan));
    }

    if (company) {
      dispatch(setBrand(company));
      dispatch(fetchBrandRegister(company));
      currentStep += 1;

      if (competitors && selectedCompetitors) {
        dispatch(setCompetitorsRegister(competitors));
        dispatch(setSelectedCompetitorsRegister(selectedCompetitors));
        currentStep += 1;
      } else {
        dispatch(fetchCompetitorsRegister(company));
      }
    }

    dispatch(setStepRegister(currentStep));
  }, [search, dispatch]);

  const onAddBrand = (brandSelected: Company) => {
    dispatch(fetchBrandRegister(brandSelected));
    dispatch(setBrand(brandSelected));
    handleFetchCompetitors(brandSelected);
    dispatch(setStepRegister(step + 1));
  }

  const handleFetchCompetitors = (company: Company) => {
    dispatch(fetchCompetitorsRegister(company));
  }

  const onAddCompetitors = (selectedCompetitors: CompetitorWithLogo[]) => {
    dispatch(setSelectedCompetitorsRegister(selectedCompetitors));
    dispatch(setStepRegister(step + 1));
  }

  return (
    <>
      {step === 1 && <AddBrand onSubmit={onAddBrand} />}
      {step === 2 && <SelectionCompetitors 
        loading={loading}
        competitors={competitorsState} 
        onSubmit={onAddCompetitors} 
        onReroll={handleFetchCompetitors} />}
      {step === 3 && <Step3 />}
    </>
  );
};

export default Register;
